import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../constants/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-50">
      <div className="mx-auto max-w-3xl px-4" data-id="element-51">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-10 text-center font-display text-3xl font-700 text-ink sm:text-4xl" data-id="element-52">
          ¿Tenés Preguntas?
        </motion.h2>

        <div className="space-y-3" data-id="element-53">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-black/5" data-id="element-54">
                <h3 data-id="element-55">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-crimson" data-id="element-56">
                    <span className="font-600 text-ink" data-id="element-57">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-crimson transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-58" />
                  </button>
                </h3>
                <motion.div initial={false} animate={{
              height: isOpen ? 'auto' : 0,
              opacity: isOpen ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-59">
                  <p className="px-5 pb-5 text-base leading-relaxed text-gray-700" data-id="element-60">
                    {faq.a}
                  </p>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}